/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *   Amina Rais - Massive Improvements
 *
 * Version: 1
 *
 *******************************************************************************/

export const SUCCESS = 'ALERT_SUCCESS'
export const ERROR = 'ALERT_ERROR'
export const CLEAR = 'ALERT_CLEAR'
